import { render, staticRenderFns } from "./SignTrainingContractModal.vue?vue&type=template&id=c89bc280"
import script from "./SignTrainingContractModal.vue?vue&type=script&lang=ts"
export * from "./SignTrainingContractModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports